import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutPartnerXCmp extends Layout {
    buttonSelectAll: Button;
    buttonUnselectAll: Button;
    horizontalspacer1: HorizontalSpacer;
    labelExcludeText: Label;
    labelIncludeText: Label;
    panelPartnerXcmp: Panel;
    panelSelectButtons: Panel;
    sourceEdipartnerXcmp: DataSource;
    tablePartnerXcmp: Table;
}
